// Mock data for Boldog Büfé - Updated Menu Structure

// Home delivery is only available within Szigethalom. Other towns must
// call the restaurant directly to arrange delivery.
export const deliveryZones = [
  { id: "szigethalom", name: "Szigethalom", fee: 700 }
];

export const restaurantInfo = {
  name: "Boldog Büfé",
  tagline: "Ha itt eszel, boldog leszel!",
  address: {
    street: "Széchenyi u. 44",
    city: "Szigethalom",
    zip: "2315",
    country: "Hungary"
  },
  phone: "+36 30 951 7159",
  rating: 5.0,
  reviewCount: 98,
  priceRange: "2000–4000 Ft",
  services: ["Helyben fogyasztás", "Elvitel", "Utcai átvétel"],
  coordinates: {
    lat: 47.3204,
    lng: 18.9973
  }
};

// Single, year-round opening hours (no summer/winter split).
// Source of truth for the Footer and Contact page hour listings.
export const openingHours = [
  { day: "Hétfő", hours: "Zárva" },
  { day: "Kedd", hours: "Zárva" },
  { day: "Szerda", hours: "08:00 – 15:00" },
  { day: "Csütörtök", hours: "08:00 – 15:00" },
  { day: "Péntek", hours: "08:00 – 15:00" },
  { day: "Szombat", hours: "08:00 – 13:00" },
  { day: "Vasárnap", hours: "08:00 – 12:00" }
];

// Packaging definitions
export const packagingItems = {
  langos: { id: "pkg-langos", name: "Lángos doboz", price: 250 },
  other: { id: "pkg-other", name: "Ételes doboz", price: 150 }
};

export const menuCategories = [
  {
    id: "langos",
    name: "Lángosok",
    description: "Friss felhős lángosaink",
    categoryImage: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/1ousryvp_IMG_20240927_080657.jpg",
    items: [
      { 
        id: "langos-1", 
        name: "Sima", 
        price: 1090,
        description: "Választható: fokhagyma + só",
        category: "Lángosok",
        productId: "langos-plain",
        packaging: "langos",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      },
      { 
        id: "langos-2", 
        name: "Tejfölös", 
        price: 1490,
        description: "Friss tejföllel",
        category: "Lángosok",
        productId: "langos-sour-cream",
        packaging: "langos",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      },
      { 
        id: "langos-3", 
        name: "Sajtos", 
        price: 1590,
        description: "Reszelt sajttal",
        category: "Lángosok",
        productId: "langos-cheese",
        packaging: "langos",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/1ousryvp_IMG_20240927_080657.jpg",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      },
      { 
        id: "langos-4", 
        name: "Sajtos-tejfölös", 
        price: 1890,
        description: "Sajt és tejföl kombinációja",
        category: "Lángosok",
        productId: "langos-cheese-cream",
        packaging: "langos",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/1ousryvp_IMG_20240927_080657.jpg",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      },
      { 
        id: "langos-5", 
        name: "Füstölt sajtos", 
        price: 1890,
        description: "Füstölt sajttal",
        category: "Lángosok",
        productId: "langos-smoked-cheese",
        packaging: "langos",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      },
      { 
        id: "langos-6", 
        name: "Füstölt sajtos-tejfölös", 
        price: 2190,
        description: "Füstölt sajt és tejföl",
        category: "Lángosok",
        productId: "langos-smoked-cheese-cream",
        packaging: "langos",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/1ousryvp_IMG_20240927_080657.jpg",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      },
      { 
        id: "langos-7", 
        name: "Ketchupos", 
        price: 1320,
        description: "Ketchuppal",
        category: "Lángosok",
        productId: "langos-ketchup",
        packaging: "langos",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      },
      { 
        id: "langos-8", 
        name: "Magyaros", 
        price: 2590,
        description: "Tejföl, fokhagyma, kolbász, hagyma",
        category: "Lángosok",
        productId: "langos-hungarian",
        packaging: "langos",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      },
      { 
        id: "langos-9", 
        name: "Gyrosos", 
        price: 2740,
        description: "Tejföl, fokhagyma, sajt, csirke gyros hús, uborka, lilahagyma",
        category: "Lángosok",
        productId: "langos-gyros",
        packaging: "langos",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/xhbldb26_IMG_20251127_192506.jpg",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      }
    ]
  },
  {
    id: "langos-laktózmentes",
    name: "Laktózmentes lángosok",
    description: "Laktózmentes változatok",
    categoryImage: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/1ousryvp_IMG_20240927_080657.jpg",
    items: [
      { 
        id: "langos-lf-1", 
        name: "Tejfölös (laktózmentes)", 
        price: 1590,
        description: "Laktózmentes tejföllel",
        category: "Laktózmentes lángosok",
        productId: "langos-lf-cream",
        packaging: "langos",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      },
      { 
        id: "langos-lf-2", 
        name: "Sajtos (laktózmentes)", 
        price: 1990,
        description: "Laktózmentes sajttal",
        category: "Laktózmentes lángosok",
        productId: "langos-lf-cheese",
        packaging: "langos",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      },
      { 
        id: "langos-lf-3", 
        name: "Sajtos-tejfölös (laktózmentes)", 
        price: 2190,
        description: "Laktózmentes sajt és tejföl kombinációja",
        category: "Laktózmentes lángosok",
        productId: "langos-lf-cheese-cream",
        packaging: "langos",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-garlic", name: "Fokhagyma", price: 0, type: "checkbox" },
          { id: "topping-salt", name: "Só", price: 0, type: "checkbox" }
        ],
        extras: [
          { id: "extra-onion", name: "Lilahagyma feltét", price: 210 }
        ]
      }
    ]
  },
  {
    id: "hotdogs",
    name: "Hot dogok",
    description: "Francia stílusú hot dog",
    categoryImage: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/qfdq9u1h_IMG-35e9202a953cd1ce2a75694ea9034470-V.jpg",
    items: [
      { 
        id: "hotdog-1", 
        name: "Klasszikus", 
        price: 1250,
        description: "Francia stílusú hot dog bükfán füstölt virslivel",
        category: "Hot dogok",
        productId: "hotdog-classic",
        packaging: "other",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/qfdq9u1h_IMG-35e9202a953cd1ce2a75694ea9034470-V.jpg",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-ketchup", name: "Ketchup", price: 200, type: "checkbox" },
          { id: "topping-mustard", name: "Mustár", price: 200, type: "checkbox" },
          { id: "topping-mayo", name: "Majonéz", price: 200, type: "checkbox" }
        ],
        spiceOptions: [
          { id: "spice-normal", name: "Normál", price: 0 },
          { id: "spice-mild", name: "Kicsit csípős", price: 50 },
          { id: "spice-extra", name: "Extrán csípős", price: 50 }
        ]
      },
      { 
        id: "hotdog-2", 
        name: "Sajtos-baconnel", 
        price: 1590,
        description: "Francia stílusú hot dog bükfán füstölt virslivel, sajttal és baconnel",
        category: "Hot dogok",
        productId: "hotdog-cheese-bacon",
        packaging: "other",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/qfdq9u1h_IMG-35e9202a953cd1ce2a75694ea9034470-V.jpg",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-ketchup", name: "Ketchup", price: 200, type: "checkbox" },
          { id: "topping-mustard", name: "Mustár", price: 200, type: "checkbox" },
          { id: "topping-mayo", name: "Majonéz", price: 200, type: "checkbox" }
        ],
        spiceOptions: [
          { id: "spice-normal", name: "Normál", price: 0 },
          { id: "spice-mild", name: "Kicsit csípős", price: 50 },
          { id: "spice-extra", name: "Extrán csípős", price: 50 }
        ]
      },
    ]
  },
  {
    id: "burgers",
    name: "Hamburgerek",
    description: "Retro hamburgerjeink",
    categoryImage: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/gjcslk2b_IMG_20250918_193225.jpg",
    items: [
      { 
        id: "burger-1", 
        name: "10 dkg-os hamburger", 
        price: 2590,
        description: "Briós buci, 98% marhahús pogácsa, csalamádé, lilahagyma, pirított hagyma, uborka, hamburger szósz",
        category: "Hamburgerek",
        productId: "burger-10dkg",
        packaging: "other",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/gjcslk2b_IMG_20250918_193225.jpg",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-ketchup", name: "Ketchup", price: 200, type: "checkbox" },
          { id: "topping-mustard", name: "Mustár", price: 200, type: "checkbox" },
          { id: "topping-mayo", name: "Majonéz", price: 200, type: "checkbox" }
        ],
        extras: [
          { id: "extra-cheese", name: "Sajtos feltét", price: 190 },
          { id: "extra-double-cheese", name: "Dupla sajt", price: 380 },
          { id: "extra-bacon", name: "Sült bacon", price: 490 },
          { id: "extra-sauce", name: "Hamburger szósz", price: 100 }
        ],
        spiceOptions: [
          { id: "spice-normal", name: "Normál", price: 0 },
          { id: "spice-mild", name: "Kicsit csípős", price: 50 },
          { id: "spice-extra", name: "Extrán csípős", price: 50 }
        ]
      },
      { 
        id: "burger-2", 
        name: "Hamburger (15 dkg hús)", 
        price: 3500,
        description: "Briós buci, 98% marhahús pogácsa, csalamádé, lilahagyma, pirított hagyma, uborka, hamburger szósz",
        category: "Hamburgerek",
        productId: "burger-15dkg",
        packaging: "other",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/d53zekch_IMG_20250528_114416.jpg",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-ketchup", name: "Ketchup", price: 200, type: "checkbox" },
          { id: "topping-mustard", name: "Mustár", price: 200, type: "checkbox" },
          { id: "topping-mayo", name: "Majonéz", price: 200, type: "checkbox" }
        ],
        extras: [
          { id: "extra-cheese", name: "Sajtos feltét", price: 190 },
          { id: "extra-double-cheese", name: "Dupla sajt", price: 380 },
          { id: "extra-bacon", name: "Sült bacon", price: 490 },
          { id: "extra-sauce", name: "Hamburger szósz", price: 100 }
        ],
        spiceOptions: [
          { id: "spice-normal", name: "Normál", price: 0 },
          { id: "spice-mild", name: "Kicsit csípős", price: 50 },
          { id: "spice-extra", name: "Extrán csípős", price: 50 }
        ]
      },
      { 
        id: "burger-3", 
        name: "Hamburger (18 dkg Angus)", 
        price: 3950,
        description: "Briós buci, 98% Angus marhahús pogácsa, csalamádé, lilahagyma, pirított hagyma, uborka, hamburger szósz",
        category: "Hamburgerek",
        productId: "burger-angus",
        packaging: "other",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/gjcslk2b_IMG_20250918_193225.jpg",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-ketchup", name: "Ketchup", price: 200, type: "checkbox" },
          { id: "topping-mustard", name: "Mustár", price: 200, type: "checkbox" },
          { id: "topping-mayo", name: "Majonéz", price: 200, type: "checkbox" }
        ],
        extras: [
          { id: "extra-cheese", name: "Sajtos feltét", price: 190 },
          { id: "extra-double-cheese", name: "Dupla sajt", price: 380 },
          { id: "extra-bacon", name: "Sült bacon", price: 490 },
          { id: "extra-sauce", name: "Hamburger szósz", price: 100 }
        ],
        spiceOptions: [
          { id: "spice-normal", name: "Normál", price: 0 },
          { id: "spice-mild", name: "Kicsit csípős", price: 50 },
          { id: "spice-extra", name: "Extrán csípős", price: 50 }
        ]
      }
    ]
  },
  {
    id: "kolbasz",
    name: "Kolbász",
    description: "Házi jellegű sült kolbászunk",
    categoryImage: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/mlnvpezq_IMG_20251127_185330.jpg",
    items: [
      { 
        id: "kolbasz-1",
        name: "Házi jellegű sült kolbász", 
        price: 1500,
        description: "Házi jellegű sült kolbász. Kb. 12–15 dkg / darab",
        category: "Kolbász",
        productId: "kolbasz-grilled",
        packaging: "other",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/mlnvpezq_IMG_20251127_185330.jpg",
        hasNoteField: true,
        sideOptions: [
          { id: "side-bread", name: "Kenyér", price: 200 },
          { id: "side-fries", name: "Hasábburgonya", price: 870 }
        ],
        toppingOptions: [
          { id: "topping-mustard", name: "Mustár", price: 200, type: "checkbox" },
          { id: "topping-ketchup", name: "Ketchup", price: 200, type: "checkbox" },
          { id: "topping-mayo", name: "Majonéz", price: 200, type: "checkbox" }
        ]
      }
    ]
  },
  {
    id: "hasabburgonya",
    name: "Köret",
    description: "Ropogós hasábburgonya",
    categoryImage: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/4kgp0jqj_1000010540.jpg",
    items: [
      {
        id: "fries-1",
        name: "Hasábburgonya",
        price: 870,
        description: "Frissen készített, aranybarna hasábburgonya",
        category: "Köret",
        productId: "fries",
        packaging: "other",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/4kgp0jqj_1000010540.jpg",
        hasNoteField: true
      },
      {
        id: "bread-1",
        name: "Kenyér",
        price: 200,
        unit: "szelet",
        description: "Friss kenyérszelet",
        category: "Köret",
        productId: "bread",
        packaging: "other",
        hasNoteField: true
      }
    ]
  },
  {
    id: "gofrik",
    name: "Gofrik",
    description: "Friss belga gofrik",
    categoryImage: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/jlyqem8c_IMG_20250312_170557.jpg",
    items: [
      { 
        id: "gofri-1",
        name: "Belga gofri", 
        price: 980,
        description: "Választható öntettel",
        category: "Gofrik",
        productId: "waffle-belgian",
        packaging: "other",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/jlyqem8c_IMG_20250312_170557.jpg",
        hasNoteField: true,
        toppingOptions: [
          { id: "topping-chocolate", name: "Csokoládé öntet", price: 0, type: "radio" },
          { id: "topping-caramel", name: "Karamell öntet", price: 0, type: "radio" },
          { id: "topping-vanilla", name: "Vanília öntet", price: 0, type: "radio" },
          { id: "topping-strawberry", name: "Szamóca öntet", price: 0, type: "radio" }
        ],
        extras: [
          { id: "extra-whipped", name: "Tejszínhab", price: 180 }
        ]
      },
      { 
        id: "gofri-2",
        name: "Cukrozott belga gofri", 
        price: 880,
        description: "Cukrozott belga gofri",
        category: "Gofrik",
        productId: "waffle-sugar",
        packaging: "other",
        image: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/9g9z562q_IMG_20250312_170936.jpg",
        hasNoteField: true
      }
    ]
  },
  {
    id: "szoszok",
    name: "Szószok",
    description: "Különféle szószok",
    items: [
      { 
        id: "sauce-1", 
        name: "Mustár", 
        price: 220,
        description: "Francia mustár",
        category: "Szószok",
        productId: "sauce-mustard",
        packaging: "other",
        hasNoteField: true
      },
      { 
        id: "sauce-2", 
        name: "Ketchup", 
        price: 220,
        description: "Paradicsom ketchup",
        category: "Szószok",
        productId: "sauce-ketchup",
        packaging: "other",
        hasNoteField: true
      },
      { 
        id: "sauce-3", 
        name: "Majonéz", 
        price: 220,
        description: "Krémes majonéz",
        category: "Szószok",
        productId: "sauce-mayo",
        packaging: "other",
        hasNoteField: true
      },
      { 
        id: "sauce-4", 
        name: "Cheddar sajtszósz", 
        price: 440,
        description: "Krémes cheddar",
        category: "Szószok",
        productId: "sauce-cheddar",
        packaging: "other",
        hasNoteField: true
      }
    ]
  },
  {
    id: "uditok",
    name: "Üdítők",
    description: "0.5L üdítők és víz",
    categoryImage: "https://images.unsplash.com/photo-1690988109029-aa2377d08b12?w=800",
    items: [
      // 0.5L Coca-Cola termékek
      { 
        id: "drink-1", 
        name: "Coca Cola", 
        price: 650,
        unit: "0.5L",
        description: "Coca-Cola termék",
        category: "Üdítők",
        productId: "drink-cola",
        packaging: null,
        hasNoteField: true
      },
      { 
        id: "drink-2", 
        name: "Coca Cola Zero", 
        price: 650,
        unit: "0.5L",
        description: "Coca-Cola termék",
        category: "Üdítők",
        productId: "drink-cola-zero",
        packaging: null,
        hasNoteField: true
      },
      { 
        id: "drink-3", 
        name: "Cappy Multi", 
        price: 650,
        unit: "0.5L",
        description: "Coca-Cola termék",
        category: "Üdítők",
        productId: "drink-cappy",
        packaging: null,
        hasNoteField: true
      },
      // 0.5L Márka
      { 
        id: "drink-4", 
        name: "Márka Narancs", 
        price: 550,
        unit: "0.5L",
        description: "Márka üdítő",
        category: "Üdítők",
        productId: "drink-marka-orange",
        packaging: null,
        hasNoteField: true
      },
      { 
        id: "drink-5", 
        name: "Márka Szőlő", 
        price: 550,
        unit: "0.5L",
        description: "Márka üdítő",
        category: "Üdítők",
        productId: "drink-marka-grape",
        packaging: null,
        hasNoteField: true
      },
      { 
        id: "drink-6", 
        name: "Márka Meggy", 
        price: 550,
        unit: "0.5L",
        description: "Márka üdítő",
        category: "Üdítők",
        productId: "drink-marka-cherry",
        packaging: null,
        hasNoteField: true
      },
      // 0.5L Víz
      { 
        id: "drink-7", 
        name: "Víz Mentes", 
        price: 300,
        unit: "0.5L",
        description: "Szénsavmentes ásványvíz",
        category: "Üdítők",
        productId: "drink-water-still",
        packaging: null,
        hasNoteField: true
      },
      { 
        id: "drink-8", 
        name: "Víz Szénsavas", 
        price: 300,
        unit: "0.5L",
        description: "Szénsavas ásványvíz",
        category: "Üdítők",
        productId: "drink-water-sparkling",
        packaging: null,
        hasNoteField: true
      }
    ]
  }
];

// Gallery images
export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/gjcslk2b_IMG_20250918_193225.jpg",
    alt: "Hamburger",
    category: "food"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/3sf8zp5z_IMG_20250528_114326.jpg",
    alt: "Dupla Hamburger",
    category: "food"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/xo54yio7_IMG_20250702_084700.jpg",
    alt: "Hamburger Közeli",
    category: "food"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/74hhw44w_IMG_20240822_172927.jpg",
    alt: "Hot Dog",
    category: "food"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/qfdq9u1h_IMG-35e9202a953cd1ce2a75694ea9034470-V.jpg",
    alt: "Francia Stílusú Hot Dog",
    category: "food"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/1ousryvp_IMG_20240927_080657.jpg",
    alt: "Sajtos-Tejfölös Lángos",
    category: "food"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/xhbldb26_IMG_20251127_192506.jpg",
    alt: "Gyrosos Lángos",
    category: "food"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/mlnvpezq_IMG_20251127_185330.jpg",
    alt: "Sült Kolbász",
    category: "food"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/4kgp0jqj_1000010540.jpg",
    alt: "Hasábburgonya",
    category: "food"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/jlyqem8c_IMG_20250312_170557.jpg",
    alt: "Belga Gofri Csokoládéval és Eperrel",
    category: "food"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/9g9z562q_IMG_20250312_170936.jpg",
    alt: "Gofri Tejszínhabbal",
    category: "food"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_hungarian-bufet/artifacts/d53zekch_IMG_20250528_114416.jpg",
    alt: "Retro Hamburger",
    category: "food"
  }
];

// Customer reviews
export const reviews = [
  {
    id: 1,
    author: "Kiss János",
    rating: 5,
    date: "2025-01-15",
    text: "Fantasztikus hamburgerek! A retro stílus és a friss alapanyagok tökéletes kombinációja. A lángos is csodálatos!",
    verified: true
  },
  {
    id: 2,
    author: "Nagy Éva",
    rating: 5,
    date: "2025-01-10",
    text: "A környék legjobb büféje! Mindig friss, mindig finom. A kiszolgálás is barátságos és gyors.",
    verified: true
  },
  {
    id: 3,
    author: "Szabó Péter",
    rating: 5,
    date: "2025-01-05",
    text: "Imádom a házias kolbászt! Autentikus ízek, kedvező árak. Csak ajánlani tudom!",
    verified: true
  }
];
